import { render, staticRenderFns } from "./new_worklist_dialog.vue?vue&type=template&id=0fac5c42&scoped=true"
import script from "./new_worklist_dialog.vue?vue&type=script&lang=js"
export * from "./new_worklist_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fac5c42",
  null
  
)

export default component.exports